// extracted by mini-css-extract-plugin
export var addButton = "_o0-0";
export var border = "_o0-8";
export var check = "_o0-h";
export var danger = "_o0-6";
export var dropdownContainer = "_o0-1";
export var editModalBody = "_o0-j";
export var footerContainer = "_o0-i";
export var fullWidth = "_o0-a";
export var hide = "_o0-9";
export var icon = "_o0-3";
export var input = "_o0-7";
export var inputFlex = "_o0-b";
export var inputWrapper = "_o0-c";
export var manualFocus = "_o0-5";
export var optionButton = "_o0-4";
export var pillWrapper = "_o0-e";
export var pointer = "_o0-2";
export var showOverflow = "_o0-f";
export var tagsFlex = "_o0-d";
export var xButton = "_o0-g";